export enum PromptResponseRatingType {
  DOWN = "DOWN",
  UP = "UP",
}
